import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Alert } from 'antd';
import { useHistory } from 'react-router-dom';
import { getGlobal, useGlobal } from 'reactn';
import api from '../../../api';
import backgroundImg from '../../assets/MCWA_Dashboard_HeroImage.jpg';
import Button from '../../common/button/Button';
import Card from '../../common/card/Card';
import ContactUs from '../../common/footer/ContactUs';
import FAQs from '../../common/footer/FAQs';
import WaterFacts from '../../common/footer/WaterFacts';
//import Form, { Input } from '../../common/form/Form';
import NeedHelp from '../../common/NeedHelp';
import Section from '../../common/section/Section';

const FindProperty = () => {
  const [foundProperty] = useGlobal('FoundAccount');
  const { serviceAccounts } = getGlobal();
  const [user] = useGlobal('user');
  const [didFindProperty, setDidFindProperty] = useState(false);
  const [propertyAdded, setPropertyAdded] = useState(false);
  const [account, setAccount] = useState(null);

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const history = useHistory();

  // hook up form and input fields with useForm
  const form = useForm();
  const { register, control, handleSubmit, formState, reset } = form;
  const { errors } = formState;

  const onSubmit = async ({ accountNo, customerCode }) => {
    setLoading(true);
    // delay feedback by at least 1 second
    setTimeout(async () => {
      const res = await api.findAccount(accountNo, customerCode);
      if (res && res.error) {
        setErrorMessage(res.error);
        setLoading(false);
        return;
      }
      setAccount({ accountNo: res.ACCOUNT, customerCode: res.CUST_CODE });
      setDidFindProperty(true);
      // setAddMoreProperties(false);
      setErrorMessage(null);
      setLoading(false);
    }, 1000);
  };

  const handleSetProperty = async () => {
    try {
      const res = await api.addProperty(
        account.accountNo,
        account.customerCode,
        user.email
      );
      if (res && res.error) {
        setErrorMessage(res.error);
      } else if (serviceAccounts.length === 0) {
        await api.setDefaultProperty(account.accountNo);
      }
    } catch (err) {
      setErrorMessage(err.response.message);
    }
    setAccount({ accountNo: '', customerCode: '' });
    reset({
      accountNo: '',
      customerCode: '',
    });
    setPropertyAdded(true);
  };

  return (
    <div>
      <Section backgroundImageUrl={backgroundImg}>
        <div className="flex flex-wrap justify-center">
          <Card
            className="w-full lg:w-1/2"
            backgroundClass="bg-white"
            title="Find Property"
            padded
          >
        <form onSubmit={handleSubmit(onSubmit)}>   
          <div>
            <label htmlFor="accountNo">Enter your account number to find your address</label>      
            <input type="text" id="accountNo" placeholder="Account Number" control={control}   disabled={loading} error="errors.accountNo"
            {...register("accountNo", {
              maxLength: {
                value: 7, 
                message: "Account number over the maximum length"},
              required: {
                value: true, 
                message: "Account number is required"},
              pattern: {
                value: /^[0-9]+$/, 
                message: "Account number can only be numbers"}
              })}
              aria-invalid={errors.accountNo? "true" : "false"} 
              className="ant-input p-4 my-2 h-auto text-lg border rounded-none"      
            />
            {<p className="text-red-500">{errors.accountNo?.message}</p>}
          </div>

          <div>
            <label htmlFor="customerCode">Enter your customer code</label>      
            <input type="text" id="customerCode" placeholder="Customer Code"  control={control}   disabled={loading}
            {...register("customerCode", {
              maxLength: {
                value: 4, 
                message: "Customer code over the maximum length"},
              required: {
                value: true, 
                message: "Customer code is required"},
              pattern: {
                value: /^[0-9]+$/, 
                message: "Customer code can only be numbers"}
              })}
              aria-invalid={errors.text ? "true" : "false"} 
              className="ant-input p-4 my-2 h-auto text-lg border rounded-none"   
             />
              {<p className="text-red-500">{errors.customerCode?.message}</p>}
          </div>
       
              {!didFindProperty && (
                <Button className="w-full" loading={loading} htmlType="submit">
                  Find Property
                </Button>
              )}

              {errorMessage && !didFindProperty && (
                <Alert  description={errorMessage} type="error" role="alert"> 
                </Alert>
              )}
        </form>  

            {!errorMessage && <> </>}
            {didFindProperty && (
              <div className="text-left">
                {!propertyAdded ? (
                  <>
                    <p className="text-blue-dark font-bold">
                      Is this the correct property?
                    </p>
                    <div className="mt-4">
                      <div className="font-bold">
                        {`${foundProperty.SA_STRNUM} ${foundProperty.SA_STRNAME}`}
                      </div>
                      <div className="font-bold">{foundProperty.SA_CITY}</div>
                      <div className="font-bold">{foundProperty.zip}</div>
                    </div>
                  </>
                ) : (
                  <>
                    {!errorMessage ? (
                      <>
                    <p className="text-blue-dark font-bold">
                      This address has been added to the customer profile.
                    </p>
                    <div className="mt-4">
                      <div className="font-bold">
                        {`${foundProperty.SA_STRNUM} ${foundProperty.SA_STRNAME}`}
                      </div>
                      <div className="font-bold">{foundProperty.SA_CITY}</div>
                    </div>
                        <div className="mt-4"></div>
                        <p>Would you like to add another address?</p>
                      </>
                    ) : (
                      <>
                      <p className="text-blue-dark font-bold">This address is already associated with a customer profile.</p>
                        <p>If you require more information, contact MCWA customer service.</p>
                          <div className="mt-4">
                      <div className="font-bold">
                        {`${foundProperty.SA_STRNUM} ${foundProperty.SA_STRNAME}`}
                      </div>
                      <div className="font-bold">{foundProperty.SA_CITY}</div>
                    </div>
                         <div className="mt-4"></div>
                        <p>Would you like try again?</p>
                        </>
                    )}
                  </>
                )}

                {propertyAdded ? (
                  <div className="flex justify-between mt-6">
                    <Button
                      className="w-full mr-4"
                      onClick={() => {
                        setPropertyAdded(false);
                        setDidFindProperty(false);
                        setErrorMessage(null);
                      }}
                    >
                      Yes
                    </Button>
                    <Button
                      className="w-full ml-4"
                      onClick={() => {
                        setDidFindProperty(false);
                        history.push('/user/dashboard');
                        window.location.reload();
                      }}
                    >
                      No
                    </Button>
                  </div>
                ) : (
                  <div className="flex justify-between mt-6">
                    <Button
                      className="w-full mr-4"
                      onClick={() => handleSetProperty()}
                    >
                      Yes
                    </Button>
                    <Button
                      className="w-full ml-4"
                      onClick={() => setDidFindProperty(false)}
                    >
                      No
                    </Button>
                  </div>
                )}
              </div>
            )}
            <NeedHelp className="pt-4" />
          </Card>
        </div>
      </Section>

      <Section>
        <div className="flex flex-wrap">
          <ContactUs className="w-full lg:w-1/3" />
          <FAQs className="w-full lg:w-1/3" />
          <WaterFacts className="w-full lg:w-1/3" />
        </div>
      </Section>
    </div>
  );
};

export default FindProperty;
